const grid = document.querySelector('.get-inspired .grid');
if (grid) {
    const setImageWidth = () => {
        const firstItem = grid.querySelector('.item');

        if (!firstItem) return;

        const width = firstItem.getBoundingClientRect().width;
        const height = firstItem.getBoundingClientRect().height;

        grid.querySelectorAll('.image-wrapper').forEach(wrapper => {
            wrapper.style.width = `${width}px`;
            wrapper.style.height = `${height}px`;
        });
    };

    setImageWidth();

    new ResizeObserver(setImageWidth).observe(grid);
}

document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('carousel-slider');

    carousels.forEach((carousel) => {
        const slider = carousel.querySelector('.slider');
        const slides = carousel.querySelectorAll('.slider__item');

        if (!slider || slides.length < 2) return;

        setInterval(() => {
            const currentScroll = slider.scrollLeft;

            // Find the slide closest to the current scroll position
            let currentIndex = 0;
            let closestDistance = Infinity;

            slides.forEach((slide, index) => {
                const distance = Math.abs(slide.offsetLeft - currentScroll);

                if (distance < closestDistance) {
                    closestDistance = distance;
                    currentIndex = index;
                }
            });

            const nextIndex = currentIndex + 1;

            if (nextIndex >= slides.length) {
                slider.scrollTo({
                    left: 0,
                    behavior: 'smooth'
                });
                return;
            }

            slider.scrollTo({
                left: slides[nextIndex].offsetLeft,
                behavior: 'smooth'
            });
        }, 4000);
    });
});

document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.main-menu__content .swiper').forEach(function (slider) {
        new Swiper(slider, {
            slidesPerView: 1.5,
            spaceBetween: 20,
            loop: false,
            speed: 1000
        });
    });
    
});